"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lotteryAssistant = require("@/api/lotteryAssistant");
var _permission = require("@/utils/permission");
var $constants = _interopRequireWildcard(require("@/utils/constants"));
var _clipboard = _interopRequireDefault(require("clipboard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 权限判断函数

var tableFroms = {
  page: 1,
  limit: $constants.page.limit[0],
  keywords: ''
};
var _default = exports.default = {
  name: 'ProductList',
  data: function data() {
    return {
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: Object.assign({}, tableFroms),
      keywords: ''
    };
  },
  computed: {},
  activated: function activated() {
    this.handleSearchList();
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:lottery-assistant:homeMenu:list'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //添加商品
    handleAdd: function handleAdd() {
      this.$router.push({
        path: "/marketing/lottery-assistant/homeMenu/createMenu/0/add"
      });
    },
    //商品操作
    handleActivity: function handleActivity(row, operate) {
      //id:商品id，operate：操作类型(edit编辑，copy复制，detail详情不可编辑)
      this.$router.push({
        path: "/marketing/lottery-assistant/homeMenu/createMenu/".concat(row.menuId, "/").concat(operate)
      });
    },
    handleStatusToggle: function handleStatusToggle(row) {
      var _this = this;
      (0, _lotteryAssistant.homeMenuStatusToggleApi)(row.menuId).then(function (res) {
        _this.$message.success('更新状态成功');
      }).catch(function () {
        _this.$message.error('更新状态失败');
        row.status = !row.status;
      });
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$modal.confirm('是否确认删除？').then(function () {
        return (0, _lotteryAssistant.homeMenuDeleteApi)(row.id);
      }).then(function () {
        _this2.getList();
        _this2.$modal.msgSuccess('删除成功');
      }).catch(function () {});
    },
    handleSearchList: function handleSearchList() {
      this.getList(1);
    },
    //重置
    handleReset: function handleReset() {
      this.tableFrom.keywords = '';
      this.keywords = '';
      this.timeVal = [];
      this.handleSearchList();
    },
    // 列表
    getList: function getList(num) {
      var _this3 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.keywords = this.keywords;
      (0, _lotteryAssistant.homeMenuListApi)(this.tableFrom).then(function (data) {
        _this3.tableData.data = data.list;
        _this3.tableData.total = data.total;
        _this3.listLoading = false;
      }).catch(function (res) {
        _this3.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    handleCopy: function handleCopy() {
      var _this4 = this;
      this.$nextTick(function () {
        var clipboard = new _clipboard.default('.copy-data');
        clipboard.on('success', function () {
          _this4.$message.success('复制成功');
          clipboard.destroy();
        });
      });
    }
  }
};